module.exports = __webpack_public_path__ + "img/1.9ee06ad9.jpg";